// Pure routing decision used by Login.tsx (email/password) after a successful sign-in for a
// role='student' profile.

/**
 * A student must be routed through /auth/select-role (which calls accept-invite) whenever
 * either:
 *   - they have no student_profiles row yet (first-ever login after confirming email), or
 *   - a pending invite token is present — including when student_profiles ALREADY exists,
 *     because a student can have more than one instructor (instructor_student_relationships'
 *     own uq_active_relationship index is scoped to (instructor_id, student_id), not
 *     student_id alone) and must still reach select-role to accept a SECOND instructor's
 *     invitation.
 */
export function shouldRouteStudentToSelectRole(hasStudentProfile: boolean, pendingInviteToken: string | null): boolean {
  return !hasStudentProfile || pendingInviteToken !== null
}
